import { Notify } from "quasar";

type Type = "positive" | "negative"

function showToaster(message: string, type: Type) {
    Notify.create({
        message,
        position: "top",
        timeout: 5000,
        type,
    });
}

export { showToaster };
